import axios from 'axios';
import Vue from 'vue';

const debug = process.env.NODE_ENV !== 'production'
let privateServiceURL = process.env.VUE_APP_PRIVATE_SERVICE_URL;
let publicServiceURL = process.env.VUE_APP_PUBLIC_SERVICE_URL;

function setPrivateServiceURL(serviceURL) {
	privateServiceURL = serviceURL;
}

const privateAPI = axios.create({
  baseURL: privateServiceURL,
  headers: { 'content-type': 'application/json'},
});

const publicAPI = axios.create({
  baseURL: publicServiceURL,
  headers: { 'content-type': 'application/json'},
});

/* Interceptors*/
// request

privateAPI.interceptors.request.use((config) => {
  if (window.$store.state.solicitud.tokenGestion) {
    config.headers['X-SOLICITUD'] = window.$store.state.solicitud.tokenGestion
  }
  
  return config;
});


// response
privateAPI.interceptors.response.use((response => {
  checkVersionHeader(response)
  return response;
}));

publicAPI.interceptors.response.use((response => {
  checkVersionHeader(response)
  return response;
}));
//Fin interceptores

// CheckVersion Functions
const title = "Recargue la página";
const text = "Esta aplicación se ha actualizado, tome nota de los datos que no haya guardado y pulse en Actualizar para continuar con su solicitud";
const buttonText = "Actualizar";
let lock = false;

const checkVersionHeader= (response) => {
  if(response.headers['x-service-version']){

    var version = response.headers['x-service-version']; // Formato: 202102.1.49-SNAPSHOT#2021-03-15T12:27:35Z
    let versionID= version.split('#')[0];
    window.localStorage.setItem('localVersion', version);

    //windows.$vue esta definido en main.js
    if(window.$vue.$appVersion != versionID){ // Caso en el que la version es la misma
      if(!lock){
        lock=true;
        window.$vue.$showMessage.confirm(title, text, buttonText).then(resp => {
          if(resp) {
            window.location.reload();
          }
        }).finally(() => lock=false);
      }
    } else if( versionID.includes('SNAPSHOT') ) { // Si la version es la misma || la hora es distinta
      manageLocalStorageVersion(version)
    }
  }
}

const manageLocalStorageVersion = (version) => {
  let localVersion = window.localStorage.getItem('localVersion');
  if(localVersion && localVersion != version){
    if(!lock){
      lock=true;
      window.$vue.$showMessage.confirm(title, text, buttonText).then(resp => {
        if(resp) {
          window.localStorage.setItem('localVersion', version)
          window.location.reload();
        }
      }).finally(() => lock=false);
    }
  } else {
    window.localStorage.setItem('localVersion', version);
  }
}

const UTILS = { 
    downloadDocument: function(response) {
        var link=document.createElement('a');

        var fileName = response.headers['x-file-name'];
        var contentType = response.headers['content-type'];
        var blob = new Blob([response.data], {type: contentType});


        //Soporte IE
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, fileName);
            return;
        }

        var url= window.URL.createObjectURL(blob);
        link.href= url;
        link.download=fileName;
        document.body.appendChild(link);
        link.click();

        setTimeout(function(){
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        }, 1000);
    }
    
} 


export { privateServiceURL, setPrivateServiceURL, publicAPI, privateAPI, UTILS };